"use client";

import * as Popover from "@radix-ui/react-popover";
import { Info } from "lucide-react";
import { ReactNode, useState } from "react";

interface InfoPopoverProps {
  content: ReactNode;
  iconClassName?: string;
}

export default function ToolTip({
  content,
  iconClassName = "",
}: InfoPopoverProps) {
  const [open, setOpen] = useState(false);

  return (
    <Popover.Root open={open} onOpenChange={setOpen}>
      <Popover.Trigger asChild>
        <button
          type="button"
          aria-label="Show information"
          className={`transition-colors duration-200 ${
            open ? "text-[#4856DD]" : "text-gray-400 hover:text-gray-600"
          } ${iconClassName}`}
        >
          <Info size={18} />
        </button>
      </Popover.Trigger>

      <Popover.Portal>
        <Popover.Content
          side="top"
          align="end"
          sideOffset={8}
          className="z-50 max-w-xs rounded-md border border-gray-200 bg-white p-3 text-sm shadow-lg"
        >
          {content}
          <Popover.Arrow className="fill-white" />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
